import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCalendar = () => {
  return (
    <g>
      <path d="M11.75 1a.75.75 0 0 1 .75.75V3H14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1.5V1.75a.75.75 0 0 1 1.5 0V3h6V1.75a.75.75 0 0 1 .75-.75zm1.75 6.5h-11v6h11v-6zm0-3h-11V6h11V4.5z" />
    </g>
  );
};

export default withIcon(IconCalendar);
